import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { QarepaBaseSubsDirective } from '@qarepa/common';
import { PaymentsService } from '@qaroni-app/payments/services/payments.service';
import { Plan } from '@qaroni-app/payments/types/plan';
import { Price } from '@qaroni-app/payments/types/price';
import { PriceConstantsEnum } from '@qaroni-app/payments/types/price-constants.enum';
import { ConfirmationDialogData } from '@qaroni-core/types/dialogs/confirmation-dialog-data';
import { QaroniDialogConfig } from '@qaroni-core/types/dialogs/qaroni-dialog-config';
import { ConfirmationDialogComponent } from '../dialogs/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: '[qaroni-payments-level]',
  templateUrl: './payments-level.component.html',
  styleUrls: ['./payments-level.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PaymentsLevelComponent extends QarepaBaseSubsDirective {
  readonly isMonthly = input<boolean>(true);
  readonly plan = input<Plan | null>(null);

  private dialog = inject(MatDialog);
  private paymentsService = inject(PaymentsService);

  get hasPrice(): boolean {
    return this.plan()?.prices?.length ? true : false;
  }

  get monthPlan(): Price {
    if (!this.hasPrice) {
      return null;
    }

    const prices: Price[] = this.plan()?.prices?.filter(
      price => price.constants === PriceConstantsEnum.MONTH
    );
    return prices[0];
  }

  get yearPlan(): Price {
    if (!this.hasPrice) {
      return null;
    }

    const prices: Price[] = this.plan()?.prices?.filter(
      price => price.constants === PriceConstantsEnum.YEAR
    );
    return prices[0];
  }

  public onWeWillContactYou(): void {
    const confirmationDialogData: ConfirmationDialogData = {
      title: $localize`Te vamos a contactar`,
      message: $localize`En los siguientes días laborales una persona del equipo de Workards se pondrá en contacto contigo para conversar sobre los niveles de precios que tenemos para ofrecerte`,
      confirmText: $localize`Continuar`,
    };

    const dialogConfig = new QaroniDialogConfig<ConfirmationDialogData>();
    dialogConfig.data = confirmationDialogData;

    const dialog = this.dialog.open<
      ConfirmationDialogComponent,
      ConfirmationDialogData,
      boolean
    >(ConfirmationDialogComponent, dialogConfig);

    this.subs.add(
      dialog.afterClosed().subscribe(this.getConfirmationWeWillContactYou)
    );
  }

  private getConfirmationWeWillContactYou = (data: boolean): void => {
    if (data) {
      this.paymentsService.weWillContactYou();
    }
  };
}
